<!-- 员工调岗申请数据操作 -->
<template>
  <div>
    <div v-if="isLoaded">
      <div class="demo-drawer__content data_action_form">
        <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="formDataList">
          <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'" :tabslist="formDataList" @tabs="(val)=>{showTabs=val}" @tabHeight="(val)=>{mxHeight=val}">
            <template slot="tabs" slot-scope="scope">
              <!-- 主要信息 -->
              <div class="table_content_box" v-if="scope.index == 0">
                <el-form label-width="120px" class="baseForm" :model="sendDataInfo" ref="sendDataInfo" size="mini" :show-message="false">
                  <el-row ref="mainForm" v-if="dataActionBox.actionType != 2">
                    <el-form-item v-if="formOneValue.isShow==1" :label="formOneValue.showField" v-for="(formOneValue,formOneKey) in scope.row.jurconfigform" :key="formOneKey" :prop="formOneValue.entityField" :rules="formOneValue.isRequired == 1 ? [{required: true,  trigger: ['blur', 'change']}] : []">
                      <template>
                        <el-date-picker v-if="formOneValue.entityField == 'ptmDate'" v-model="sendDataInfo[formOneValue.entityField]" type="date" placeholder="选择日期" style="width: 100%;" value-format="timestamp" :disabled="formOneValue.isChange == 0"></el-date-picker>

                        <!-- 新部门 -->
                        <el-tooltip v-else-if="formOneValue.entityField == 'inDep'" class="item" :disabled="sendDataInfo.inDepName==null||sendDataInfo.inDepName==''?true:false || sendDataInfo.inDepName.length<=9" effect="dark"
        :content="sendDataInfo.inDepName" placement="bottom-start">
                        <el-input  :clearable="true" @keyup.enter.native="openSearch(formOneValue.searchId, 'inDep')" :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2" v-model="sendDataInfo.inDepName" :maxlength="$store.state.inputLength">
                          <el-button @click="openSearch(formOneValue.searchId, formOneValue.entityField, formOneValue.setField)" slot="append" icon="el-icon-search"></el-button>
                        </el-input>
                        </el-tooltip>
                        <!-- 旧部门 -->
                        <el-input :clearable="true" v-else-if="formOneValue.entityField == 'outDep'" :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2" v-model="sendDataInfo.outDepName" :maxlength="$store.state.inputLength"></el-input>
                        <!-- 请假人	 -->
                        <el-tooltip v-else-if="formOneValue.entityField == 'opmId'" class="item" :disabled="sendDataInfo.opmName==null||sendDataInfo.opmName==''?true:false || sendDataInfo.opmName.length<=9" effect="dark"
        :content="sendDataInfo.opmName" placement="bottom-start">
                        <el-input  :clearable="true" @keyup.enter.native="openSearch(formOneValue.searchId, 'opmId')" :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2" v-model="sendDataInfo.opmName" :maxlength="$store.state.inputLength">
                          <el-button @click="openSearch(formOneValue.searchId, formOneValue.entityField, formOneValue.setField)" slot="append" icon="el-icon-search"></el-button>

                        </el-input>
</el-tooltip>
                        <!-- 原因 -->
                        <el-input clearable v-else-if="formOneValue.entityField == 'ptmReason'" :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2" v-model="sendDataInfo[formOneValue.entityField]" :maxlength="$store.state.inputLength" type="textarea"></el-input>

                        <!-- 性别 -->
                        <el-radio-group v-else-if="formOneValue.entityField == 'opmSex'" v-model="sendDataInfo.opmSex" size="mini">
                          <el-radio-button label="男">男</el-radio-button>
                          <el-radio-button label="女">女</el-radio-button>
                        </el-radio-group>
                        <!-- 是否采购员 -->
                        <el-radio-group v-else-if="formOneValue.entityField == 'opmBuyer'" v-model="sendDataInfo.opmBuyer" size="mini">
                          <el-radio-button label="0">否</el-radio-button>
                          <el-radio-button label="1">是</el-radio-button>
                        </el-radio-group>
                        <!-- 是否销售员 -->
                        <el-radio-group v-else-if="formOneValue.entityField == 'opmSalesperson'" v-model="sendDataInfo.opmSalesperson" size="mini">
                          <el-radio-button label="0">否</el-radio-button>
                          <el-radio-button label="1">是</el-radio-button>
                        </el-radio-group>
                        <!-- 是否保管员 -->
                        <el-radio-group v-else-if="formOneValue.entityField == 'opmKeeper'" v-model="sendDataInfo.opmKeeper" size="mini">
                          <el-radio-button label="0">否</el-radio-button>
                          <el-radio-button label="1">是</el-radio-button>
                        </el-radio-group>
                        <!-- 是否执业药师 -->
                        <el-radio-group v-else-if="formOneValue.entityField == 'opmPharmacist'" v-model="sendDataInfo.opmPharmacist" size="mini">
                          <el-radio-button label="0">否</el-radio-button>
                          <el-radio-button label="1">是</el-radio-button>
                        </el-radio-group>
                        <!-- 是否配送员 -->
                        <el-radio-group v-else-if="formOneValue.entityField == 'opmDistributor'" v-model="sendDataInfo.opmDistributor" size="mini">
                          <el-radio-button label="0">否</el-radio-button>
                          <el-radio-button label="1">是</el-radio-button>
                        </el-radio-group>
                        <!-- 是否司机 -->
                        <el-radio-group v-else-if="formOneValue.entityField == 'opmDriver'" v-model="sendDataInfo.opmDriver" size="mini">
                          <el-radio-button label="0">否</el-radio-button>
                          <el-radio-button label="1">是</el-radio-button>
                        </el-radio-group>
                        <!-- 是否验收人 -->
                        <el-radio-group v-else-if="formOneValue.entityField == 'opmAcceptor'" v-model="sendDataInfo.opmAcceptor" size="mini">
                          <el-radio-button label="0">否</el-radio-button>
                          <el-radio-button label="1">是</el-radio-button>
                        </el-radio-group>
                        <!-- 是否复核人 -->
                        <el-radio-group v-else-if="formOneValue.entityField == 'opmReviewer'" v-model="sendDataInfo.opmReviewer" size="mini">
                          <el-radio-button label="0">否</el-radio-button>
                          <el-radio-button label="1">是</el-radio-button>
                        </el-radio-group>
                        <!-- 是否收款员 -->
                        <el-radio-group v-else-if="formOneValue.entityField == 'opmCashier'" v-model="sendDataInfo.opmCashier" size="mini">
                          <el-radio-button label="0">否</el-radio-button>
                          <el-radio-button label="1">是</el-radio-button>
                        </el-radio-group>
                        <!-- 是否医师 -->
                        <el-radio-group v-else-if="formOneValue.entityField == 'opmDoctor'" v-model="sendDataInfo.opmDoctor" size="mini">
                          <el-radio-button label="0">否</el-radio-button>
                          <el-radio-button label="1">是</el-radio-button>
                        </el-radio-group>
                        <!-- 是否部门主管 -->
                        <el-radio-group v-else-if="formOneValue.entityField == 'opmHeader'" v-model="sendDataInfo.opmHeader" size="mini">
                          <el-radio-button label="0">否</el-radio-button>
                          <el-radio-button label="1">是</el-radio-button>
                        </el-radio-group>

                        <!-- 备注 -->
                        <el-input clearable v-else-if="formOneValue.entityField == 'ptmRemark'" :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2" v-model="sendDataInfo[formOneValue.entityField]" :maxlength="$store.state.inputLength" type="textarea"></el-input>

                        <el-input v-else clearable :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2" v-model.trim="sendDataInfo[formOneValue.entityField]" :maxlength="$store.state.inputLength"></el-input>
                      </template>

                    </el-form-item>
                  </el-row>
                  <el-row ref="mainForm" v-if="dataActionBox.actionType == 2">
                    <el-form-item v-if="formOneValue.isShow==1" :label="formOneValue.showField+':'" v-for="(formOneValue,formOneKey) in scope.row.jurconfigform" :key="formOneKey" :prop="formOneValue.entityField" :rules="formOneValue.isRequired == 1 ? [{required: true,  trigger: ['blur', 'change']}] : []">
                      <template>
                        <span v-if="formOneValue.isRift == 1">
                          <a @click="toDetail(sendDataInfo[formOneValue.riftField])">{{sendDataInfo[formOneValue.entityField]}}</a>
                        </span>
                        <span v-else-if="formOneValue.entityField == 'purmSdate'">{{$common.getLocalTime(sendDataInfo[formOneValue.entityField])}}</span>
                        <span v-else-if="formOneValue.entityField == 'smId'">{{sendDataInfo.smName}}</span>
                        <span v-else-if="formOneValue.entityField == 'opmId'">{{sendDataInfo.opmName}}</span>
                        <span v-else-if="formOneValue.entityField == 'depId'">{{sendDataInfo.depName}}</span>
                        <span v-else-if="formOneValue.entityField == 'isWms'">{{sendDataInfo[formOneValue.entityField] == 0? '否' : '新增'}}</span>
                        <span v-else>{{sendDataInfo[formOneValue.entityField]}}</span>
                      </template>
                    </el-form-item>
                  </el-row>
                </el-form>
              </div>
            </template>
          </v-tabs>
        </el-card>

        <div class="foot">
          <el-button v-if="dataActionBox.actionType!=2" type="primary" @click="initActionBox('sendDataInfo')">取消</el-button>
          <el-button type="primary" @click="sendDataAction('sendDataInfo')" v-if="dataActionBox.actionType==0">保存</el-button>
          <el-button type="primary" @click="sendDataAction('sendDataInfo')" v-if="dataActionBox.actionType==1">保存</el-button>
        </div>

      </div>
    </div>

    <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" :modal-append-to-body='true' :append-to-body="true">
      <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
    </el-dialog>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../byComponents/SearchScheme.vue"

export default {
  name: 'employeeTransferAction',
  props: ['actionData'],
  //import引入的组件需要注入到对象中才能使用
  components: {
    SearchScheme,
  },
  data() {
    //这里存放数据
    return {
      dataActionBox: {
        showStatus: false,
        openMode: 'ltr' || 'rtl',
        boxTitle: '新增' || '编辑',
        actionType: 0, // 0新增，1修改
      },
      detaislDataInfo: {},
      selectedDataIndex: 0,
      sendDataInfo: {
        inDep: '', //	新部门
        inDepName: '', //	新部门
        opmAcceptor: '', //	是否验收人
        opmBuyer: '', //	是否采购员
        opmCashier: '', //	是否收款员
        opmDistributor: '', //	是否配送员
        opmDoctor: '', //	是否医师
        opmDriver: '', //	是否司机
        opmHeader: '', //	是否部门主管
        opmKeeper: '', //	是否保管员
        opmPharmacist: '', //	是否执业药师
        opmReviewer: '', //	是否复核人
        opmSalesperson: '', //	是否销售员
        outDep: '', //	原部门
        outDepName: '', //	原部门
        ptmDate: '', //请日期
        opmId: '', //	申请人
        ptmReason: '', //	调岗理由
        ptmRemark: '', //	备注
      },
      showTabs: '',
      formDataList: [],
      DialogVisible: false, //检索
      seId: "",
      seWidth: "",
      seTitle: "",
      seType: '',
      isLoaded: false,
      parentSearchData: {
        opmDriver: '',
        opmBuyer: ''
      },


    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    toDetail(orderId) {
      this.$parent.$parent.$parent.toDetail(orderId)
      // this.$emit('toDetail',orderId)
    },

    // 检索Id, 索引(表格中), 标识
    openSearch(sId, type) {
      this.seId = sId
      this.seType = type
      this.DialogVisible = true
      this.parentSearchData[type] = this.sendDataInfo[type]
      if (type == "opmId") {
        this.parentSearchData.opmName = this.sendDataInfo.opmName
      } else if (type == "inDep") {
        this.parentSearchData.depName = this.sendDataInfo.inDepName

      }
    },
    //提取返回
    changeInputModel(val) {
      console.log(val)
      if (val != "" || val != undefined) {
        if (this.seType == 'opmId') {
          this.sendDataInfo.opmId = val.opmId
          this.sendDataInfo.opmName = val.opmName
          this.sendDataInfo.outDep = val.depId
          this.sendDataInfo.outDepName = val.depName

          for (const key in this.sendDataInfo) {
            for (const childKey in val) {
              if (key == childKey) {
                this.sendDataInfo[key] = val[childKey]
              }
            }
          }
        } else if (this.seType == 'inDep') {
          this.sendDataInfo.inDep = val.depId
          this.sendDataInfo.inDepName = val.depName
        }
        this.DialogVisible = false
      }
    },
    getSeWidth(e) {
      this.seWidth = e + "%";
    },
    getSearchName(e) {
      this.seTitle = e;
    },

    tableRowClassName({
      row,
      rowIndex
    }) {
      row.index = rowIndex;
    },

    //确认新增
    sendDataAction(formName1) {
      this.$refs[formName1].validate((valid) => {
        if (valid) {
          // console.log(this.sendDataInfo)
          this.sub()
        } else {
          this.$message({
            message: '请完善必填信息',
            type: 'error'
          })
          return false;
        }
      })
    },
    async sub() {
      var responseData
      if (this.dataActionBox.actionType == 0) {
        responseData = await this.$http.pensonelAddTransfer(this.sendDataInfo)
      } else {
        responseData = await this.$http.pensonelUpdateTransfer(this.sendDataInfo)
      }
      if (responseData.status == 200) {
        this.init()
        this.$message({
          message: '操作成功',
          type: 'success'
        });
        this.$emit('drawerCancel')
      } else {
        this.$message({
          message: responseData.message,
          type: 'error'
        });
      }
    },

    //取消
    initActionBox(sendDataInfo) {
      var cancelTitle = this.dataActionBox.actionType == 0 ? '新增' : '修改'
      this.$confirm('确定取消' + cancelTitle + '吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$emit('drawerCancel')
        this.init()
        this.$refs[sendDataInfo].resetFields();
      }).catch(() => { });
    },
    //初始化
    init() {
      for (let key in this.sendDataInfo) {
        if (key == 'ptmDate') {
          this.sendDataInfo[key] = this.$moment().valueOf()
        } else if (key == 'inDepName' || key == 'ptmReason' || key == 'ptmRemark' || key == 'opmEmail' || key == 'opmIdnumber' || key == 'opmMobilenumber' || key == 'opmTelenumber' || key == 'outDepName') {
          this.sendDataInfo[key] = ''
        } else {
          this.sendDataInfo[key] = '0'
        }
        this.sendDataInfo.opmSex = '男' //	男
        this.sendDataInfo.inDep = '' //	部门id
        this.sendDataInfo.outDep = '' //	部门id
      }
    },
    //父级传入
    openBox(cate, formData, oldData = '') {
      this.showTabs = formData[0].jciName
      this.formDataList = formData

      this.init()
      if (cate == 0) {
        this.dataActionBox.boxTitle = '新增信息'
        this.dataActionBox.openMode = 'ltr'
      } else if (cate == 1) {
        this.dataActionBox.boxTitle = '编辑信息'
        this.dataActionBox.openMode = 'rtl'
        var dataInfo = JSON.parse(JSON.stringify(oldData))
        for (let key in dataInfo) {
          this.sendDataInfo[key] = dataInfo[key]
        }
      } else {
        this.dataActionBox.boxTitle = '查看信息'
        var dataInfo = JSON.parse(JSON.stringify(oldData))
        for (let key in dataInfo) {
          this.sendDataInfo[key] = dataInfo[key]
        }
      }
      this.dataActionBox.actionType = cate
      this.dataActionBox.showStatus = true
    },

  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.$nextTick(() => {
      var params = this.actionData
      this.openBox(params.cate, params.formData, params.oldData)
      this.isLoaded = true
    })
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {

  },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() { }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
  activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style scoped>
.table_button_box {
  height: 200px;
  background-color: red;
}

.table_content_box {
  overflow-y: auto;
}

.el-row {
  display: flex;
  flex-wrap: wrap;
  padding-right: 20px;
}

.el-drawer {
  outline: none;
}
</style>
